/*
============================================================
ZB MODE — PRODUCT SHARING
File: assets/zb-social-sharing.js

- Native device sharing
- Direct WhatsApp sharing
- Copy link confirmation
============================================================
*/

(function () {
  function initializeShareBlock(root) {
    if (!root || root.dataset.zbShareInitialized === 'true') {
      return;
    }

    root.dataset.zbShareInitialized = 'true';

    const shareButton = root.querySelector('[data-zb-native-share]');
    const copyButton = root.querySelector('[data-zb-copy-link]');
    const status = root.querySelector('[data-zb-copy-status]');

    const shareUrl =
      root.dataset.shareUrl ||
      window.location.href;

    const shareTitle =
      root.dataset.shareTitle ||
      document.title;

    let statusTimer;

    function showCopiedMessage() {
      if (!status) {
        return;
      }

      window.clearTimeout(statusTimer);

      status.classList.add('is-visible');

      statusTimer = window.setTimeout(function () {
        status.classList.remove('is-visible');
      }, 1800);
    }

    function fallbackCopy(text) {
      const textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');

      document.body.removeChild(textarea);

      return copied;
    }

    async function copyShareUrl() {
      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === 'function'
        ) {
          await navigator.clipboard.writeText(shareUrl);
        } else {
          fallbackCopy(shareUrl);
        }

        showCopiedMessage();
      } catch (error) {
        const copied = fallbackCopy(shareUrl);

        if (copied) {
          showCopiedMessage();
        }
      }
    }

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        copyShareUrl();
      });
    }

    if (shareButton) {
      shareButton.addEventListener('click', async function () {
        if (typeof navigator.share !== 'function') {
          await copyShareUrl();
          return;
        }

        try {
          await navigator.share({
            title: shareTitle,
            text: shareTitle,
            url: shareUrl
          });
        } catch (error) {
          /*
           * AbortError means the visitor closed the native share menu.
           * No error message is needed in that situation.
           */
          if (error && error.name !== 'AbortError') {
            await copyShareUrl();
          }
        }
      });
    }
  }

  function initializeAllShareBlocks() {
    document
      .querySelectorAll('[data-zb-share-root]')
      .forEach(initializeShareBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllShareBlocks
    );
  } else {
    initializeAllShareBlocks();
  }

  /*
   * Reinitialize when Shopify reloads a section
   * inside the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    initializeAllShareBlocks
  );
})();